function getTreeParentHeaderAlert(page) {
    if (!page.treeParent) {
        return null;
    } else if (page.treeParent.headerAlert) {
        return page.treeParent.headerAlert;
    } else if (page.treeParent) {
        return getTreeParentHeaderAlert(page.treeParent);
    }

    return null;
}

export default function getHeaderAlert(page) {
    if (page.headerAlert) {
        return page.headerAlert;
    }

    return getTreeParentHeaderAlert(page);
}